import * as React from 'react';
import jwtDecode from 'jwt-decode';
import * as Sentry from '@sentry/react';
import * as config from 'src/shared/config';
import client from 'legacy/apollo';

const tokenContext = React.createContext({});

export const TokenProvider = ({ children }) => {
  const [token, setToken] = React.useState(() => ({
    accessToken: localStorage.getItem(config.ACCESS_TOKEN_KEY),
    refreshToken: localStorage.getItem(config.REFRESH_TOKEN_KEY),
  }));
  const [coachToken, setCoachToken] = React.useState(() => ({
    accessToken: localStorage.getItem(config.ACCESS_TOKEN_KEY_COACH),
    refreshToken: localStorage.getItem(config.REFRESH_TOKEN_KEY_COACH),
  }));

  const saveToken = React.useCallback(
    (_tokens) => {
      if (_tokens && Object.keys(_tokens).length > 0) {
        localStorage.setItem(config.ACCESS_TOKEN_KEY, _tokens.accessToken);
        localStorage.setItem(config.REFRESH_TOKEN_KEY, _tokens.refreshToken);
        setToken(_tokens);
        client.resetStore();
      } else {
        localStorage.removeItem(config.ACCESS_TOKEN_KEY);
        localStorage.removeItem(config.REFRESH_TOKEN_KEY);
        setToken(null);
        client.resetStore();
      }
    },
    [setToken],
  );

  const saveCoachToken = React.useCallback(
    (_tokens) => {
      if (_tokens && Object.keys(_tokens).length > 0) {
        localStorage.setItem(
          config.ACCESS_TOKEN_KEY_COACH,
          _tokens.accessToken,
        );
        localStorage.setItem(
          config.REFRESH_TOKEN_KEY_COACH,
          _tokens.refreshToken,
        );
        setCoachToken(_tokens);
      } else {
        localStorage.removeItem(config.REFRESH_TOKEN_KEY_COACH);
        localStorage.removeItem(config.ACCESS_TOKEN_KEY_COACH);
        setCoachToken(null);
      }
    },
    [setCoachToken],
  );

  const saveTemporaryToken = React.useCallback((_token) => {
    if (_token) {
      localStorage.setItem(config.ACCESS_TOKEN_KEY, _token);
    } else {
      localStorage.removeItem(config.ACCESS_TOKEN_KEY);
    }
  }, []);

  const decoded = React.useMemo(() => {
    try {
      const data = jwtDecode(token.accessToken);
      const { id, roleName, scopeName, userName } = data;
      Sentry.setUser({ id, roleName, scopeName, userName });
      return data;
    } catch (error) {
      return null;
    }
  }, [token]);

  const coachTokendecoded = React.useMemo(() => {
    try {
      const data = jwtDecode(coachToken.accessToken);
      return data;
    } catch (error) {
      return null;
    }
  }, [coachToken]);

  // const isMaintenanceMode = IS_ON_MAINTENANCE === 'true';
  return (
    <tokenContext.Provider
      value={{
        token,
        decoded,
        coachTokendecoded,
        saveToken,
        saveTemporaryToken,
        saveCoachToken,
      }}
    >
      {children}
    </tokenContext.Provider>
  );
};

export const useTokenContext = () => React.useContext(tokenContext);
